import React from 'react';
import { CardMenu } from '../card-menu/CardMenu';
import './CardAnalytics.scss';
import { Button } from 'devextreme-react';
import { useNavigate } from 'react-router-dom';


const menuItems = [
  { text: 'Configure' },
  { text: 'Remove' },
];

export const CardAnalytics = ({
  title,
  contentClass,
  isLoading = false,
  children,
  additionalHeaderContent,
  menuVisible = true,
  buttonVisible = false,
  buttonText = '',
  buttonIcon = '',
  buttonLink = ''
}) => {
  const navigate = useNavigate();
  return (
    <div className={`card ${contentClass}`}>
      <div className='header'>
        <CardMenu visible={menuVisible} items={menuItems} />
        <Button visible={buttonVisible} text={buttonText} icon={buttonIcon} type="default" onClick={() => navigate(buttonLink)} className='overflow-menu' />
        {title && <div className='title'>{title}</div>}
        {additionalHeaderContent}
      </div>
      {!isLoading && <div className='card-contents'>{children}</div>}
    </div>
  );
};
